export const WEB_PUSH_PERMISSION_CHECK_EVENT = 'web-push-permission-check';

export function checkWebPushPermission() {
  window.dispatchEvent(new Event(WEB_PUSH_PERMISSION_CHECK_EVENT));
}
